import { FORM_FIELDS, FORM_FIELDS_NAMES } from './new-application-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { ISelectorData } from '../../components/application/NewApplication';
import { TFunction } from 'react-i18next';
import { ILists } from '../../interfaces/merchant';
import { yesNoList } from '../application-view/company-info-inputs';

interface IBusinessInformationInputsProps {
  mccList: ISelectorData[];
  lists: ILists;
  t: TFunction;
}

export const SUPER_ADMIN_BUSINESS_INFORMATION_INPUTS = ({ lists, t, mccList }: IBusinessInformationInputsProps): IFormInputProps[] => [
  {
    key: FORM_FIELDS.COMPANY_NAME,
    fieldName: FORM_FIELDS.COMPANY_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.COMPANY_NAME)}`,
    label: t(FORM_FIELDS_NAMES.COMPANY_NAME),
    inputType: InputType.Text,
    required: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.DOING_BUSINESS,
    fieldName: FORM_FIELDS.DOING_BUSINESS,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.DOING_BUSINESS)}`,
    label: t(FORM_FIELDS_NAMES.DOING_BUSINESS),
    inputType: InputType.Text,
    required: true,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.ANNUAL_SALES_VOLUME,
    fieldName: FORM_FIELDS.ANNUAL_SALES_VOLUME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME)}`,
    label: t(FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME),
    inputType: InputType.Number,
    required: true,
    autoComplete: 'off',
    prefix: '$',
    useNumberFormatter: true,
    shouldFormat: true,
  },
  {
    key: FORM_FIELDS.DECLINE_RATE,
    fieldName: FORM_FIELDS.DECLINE_RATE,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.DECLINE_RATE)}`,
    label: t(FORM_FIELDS_NAMES.DECLINE_RATE),
    inputType: InputType.Number,
    autoComplete: 'off',
    suffix: '%',
    min: 0,
    max: 100
  },
  {
    key: FORM_FIELDS.TAX,
    fieldName: FORM_FIELDS.TAX,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.TAX)}`,
    label: t(FORM_FIELDS_NAMES.TAX),
    inputType: InputType.Text,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.IS_BASED_IN_US,
    fieldName: FORM_FIELDS.IS_BASED_IN_US,
    label: t(FORM_FIELDS_NAMES.IS_BASED_IN_US),
    inputType: InputType.Select,
    data: yesNoList,
    cleanable: false,
    searchable: false,
    isLabelIcon: true,
    tooltipText: t(FORM_FIELDS_NAMES.IS_BASED_IN_US_TOOLTIP),
    autoComplete: 'off'
  },
  // {
  //   key: FORM_FIELDS.BUSINESS_TYPE,
  //   fieldName: FORM_FIELDS.BUSINESS_TYPE,
  //   placeholder: t(FORM_FIELDS_NAMES.BUSINESS_TYPE),
  //   label: t(FORM_FIELDS_NAMES.BUSINESS_TYPE),
  //   inputType: InputType.Select,
  //   // required: true,
  //   dataCy: 'business_type',
  //   data: lists.businessTypes,
  //   autoComplete: 'off'
  // },
  {
    key: FORM_FIELDS.PLATFORM,
    fieldName: FORM_FIELDS.PLATFORM,
    placeholder: t(FORM_FIELDS_NAMES.PLATFORM),
    label: t(FORM_FIELDS_NAMES.PLATFORM),
    inputType: InputType.Select,
    data: lists.ecommercePlatforms,
    dataCy: 'platform',
    placement: 'bottomEnd',
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.BUSINESS_ESTABLISHED_DATE,
    fieldName: FORM_FIELDS.BUSINESS_ESTABLISHED_DATE,
    label: t(FORM_FIELDS_NAMES.BUSINESS_ESTABLISHED_DATE),
    inputType: InputType.Date,
    autoComplete: 'off'
  },
  // {
  //   key: FORM_FIELDS.PLATFORM_USAGE_PERIOD,
  //   fieldName: FORM_FIELDS.PLATFORM_USAGE_PERIOD,
  //   label: t(FORM_FIELDS_NAMES.PLATFORM_USAGE_PERIOD),
  //   tooltipText: t(FORM_FIELDS_NAMES.PLATFORM_USAGE_PERIOD_TOOLTIP),
  //   isLabelIcon: true,
  //   inputType: InputType.Select,
  //   data: lists.timeInBusiness,
  //   searchable: false,
  //   autoComplete: 'off'
  // },
  {
    key: FORM_FIELDS.MCC,
    fieldName: FORM_FIELDS.MCC,
    placeholder: t(FORM_FIELDS_NAMES.MCC),
    label: t(FORM_FIELDS_NAMES.MCC),
    inputType: InputType.Select,
    // required: true,
    data: mccList,
    dataCy: 'mcc',
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.DESCRIPTOR,
    fieldName: FORM_FIELDS.DESCRIPTOR,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.DESCRIPTOR)}`,
    label: t(FORM_FIELDS_NAMES.DESCRIPTOR),
    inputType: InputType.Text,
    // required: true,
    autoComplete: 'off'
  },
];


